import { CardSubtitle } from "../../types/CoreComponents";
import { BorderColorItems, FontStyle, ImageItem } from "../../types/UiKits";

export const BorderStyleSubTitle: CardSubtitle[] = [
  {
    text: "Use the different styles of borders like: ",
    code: "border radius/border-color/border-width",
  },
  {
    text: ". Use of any components.",
  },
];

export const BackgroundColorSubTitle: CardSubtitle[] = [
  {
    text: "Use the ",
    code: ".bg-* ",
  },
  {
    text: "and ",
    code: ".alert-light-* ",
  },
  {
    text: "colors in Zono theme. Use of any components.",
  },
];

export const BorderColorSubTitle: CardSubtitle[] = [
  {
    text: "Use the ",
    code: ".b-*/.b-t-*/.b-b-*/.b-l-*/.b-r-*",
  },
  {
    text: "class for borders.",
  },
];

export const ImageSubTitle: CardSubtitle[] = [
  {
    text: "Use the width and height of images class like: ",
    code: ".img-*",
  },
  {
    text: "&",
    code: ".img-h",
  },
  {
    text: ".",
  },
];

export const FontStyleSubTitle: CardSubtitle[] = [
  {
    text: "Use the font-style like: ",
    code: " .f-s-* [normal/italic/oblique/initial/inherit]",
  },
  {
    text: ".",
  },
];

export const FontWeightSubTitle: CardSubtitle[] = [
  {
    text: "Use the font-weight classes like: ",
    code: ".f-w-* [100/300/400/600/700/900]",
  },
];

export const TextColorSubTitle: CardSubtitle[] = [
  {
    text: "Use the text color for ",
    code: ".font-*",
  },
  {
    text: " class.",
  },
];

export const FontSizeSubTitle: CardSubtitle[] = [
  {
    text: "Use the font-size for ",
    code: ".f-* [14/16/18/20/22/24/26/28/30/32/34/36/38/40]",
  },
  {
    text: ".",
  },
];

export const BordersAndDisplaySubTitle: CardSubtitle[] = [
  {
    text: "Use border utilities to add or remove an element's borders.",
  },
];

export const BorderColorData: BorderColorItems[] = [
  {
    id: 1,
    color: "primary",
  },
  {
    id: 2,
    color: "secondary",
  },
  {
    id: 3,
    color: "success",
  },
  {
    id: 4,
    color: "danger",
  },
  {
    id: 5,
    color: "warning",
  },
  {
    id: 6,
    color: "info",
  },
  {
    id: 7,
    color: "dark",
  },
  {
    id: 8,
    color: "light",
  },
];

export const AdditiveBorderData: string[] = ["border", "border-top", "border-bottom", "border-start", "border-end"];

export const AdditiveRadiusData: string[] = ["rounded", "rounded-top", "rounded-end", "rounded-bottom", "rounded-start", "rounded-pill", "rounded-circle", "rounded-0"];

export const BorderSideColorData: string[] = ["b-primary", "b-t-primary", "b-b-primary", "b-l-primary", "b-r-primary", "b-secondary", "b-t-secondary", "b-b-secondary", "b-l-secondary", "b-r-secondary", "b-success", "b-t-success", "b-b-success", "b-l-success", "b-r-success", "b-danger", "b-t-danger", "b-b-danger", "b-l-danger", "b-r-danger", "b-warning", "b-t-warning", "b-b-warning", "b-l-warning", "b-r-warning", "b-info", "b-t-info", "b-b-info", "b-l-info", "b-r-info", "b-dark", "b-t-dark", "b-b-dark", "b-l-dark", "b-r-dark", "b-light", "b-t-light", "b-b-light", "b-l-light", "b-r-light"];

export const ImageData: ImageItem[] = [{ size: "30" }, { size: "40" }, { size: "50" }, { size: "60" }, { size: "70" }, { size: "80" }, { size: "90" }, { size: "100" }];

export const FontStyleData: string[] = ["normal", "italic", "oblique", "initial", "inherit"];

export const FontWeightData: FontStyle[] = [
  {
    class: "100",
    text: "You can set light font weight heading .f-w-100",
  },
  {
    class: "300",
    text: "You can set light font weight heading .f-w-300",
  },
  {
    class: "400",
    text: "You can set light font weight heading .f-w-400",
  },
  {
    class: "600",
    text: "You can set bolder font weight heading .f-w-600",
  },
  {
    class: "700",
    text: "You can set bold font weight heading .f-w-700",
  },
  {
    class: "900",
    text: "You can set bold font weight heading .f-w-900",
  },
];

export const TextColorsData: FontStyle[] = [
  {
    class: "font-primary",
    text: "This is a ",
    text2: "text used class as .font-primary",
  },
  {
    class: "font-secondary",
    text: "This is a ",
    text2: "text used class as .font-secondary",
  },
  {
    class: "font-success",
    text2: "text used class as .font-success",
    text: "This is a ",
  },
  {
    class: "font-danger",
    text2: "text used class as .font-danger",
    text: "This is a ",
  },
  {
    class: "font-warning",
    text2: "text used class as .font-warning",
    text: "This is a ",
  },
  {
    class: "font-info",
    text2: "text used class as .font-info",
    text: "This is a ",
  },
  {
    class: "font-dark",
    text2: "text used class as .font-dark",
    text: "This is a ",
  },
];

export const FontSizeData: number[] = [14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40];
